import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions, URLSearchParams } from '@angular/http';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { CurrencyType } from '@app/core/balance.service';
import { map } from 'rxjs/operators';

class GameDetails {
  name: string;
  title: string;
  icon: string;
}

@Injectable()
export class GamesService {
  gameFlowInAction: boolean = false;
  gamesList: string[] = [
    'dice',
    'spooky-dice',
    'ice-dice',
    'crash',
    'blackjack',
    'baccarat',
    'slots',
    'crypto-gems',
    'roulette',
    'treasure-hunt',
    'video-poker',
    'hi-lo',
    'casino-war',
    'under-the-aegis',
  ];
  gamesDetails: Array<GameDetails> = [
    {
      name: 'dice',
      title: 'Dice',
      icon: '/assets/images/v2/games/icons/dice.svg',
    },
    {
      name: 'spooky-dice',
      title: 'Spooky dice',
      icon: '/assets/images/v2/games/icons/spooky-dice.svg',
    },
    {
      name: 'ice-dice',
      title: 'Ice dice',
      icon: '/assets/images/v2/games/icons/ice-dice.svg',
    },
    {
      name: 'crash',
      title: 'Crash',
      icon: '/assets/images/v2/games/icons/crash.svg',
    },
    {
      name: 'blackjack',
      title: 'Blackjack',
      icon: '/assets/images/v2/games/icons/blackjack.svg',
    },
    {
      name: 'baccarat',
      title: 'Baccarat',
      icon: '/assets/images/v2/games/icons/baccarat.svg',
    },
    {
      name: 'slots',
      title: 'Slots',
      icon: '/assets/images/v2/games/icons/slots.svg',
    },
    {
      name: 'crypto-gems',
      title: 'Crypto gems',
      icon: '/assets/images/v2/games/icons/slots.svg',
    },
    {
      name: 'roulette',
      title: 'Roulette',
      icon: '/assets/images/v2/games/icons/roulette.svg',
    },
    {
      name: 'treasure-hunt',
      title: 'Treasure hunt',
      icon: '/assets/images/v2/games/icons/treasure-hunt.svg',
    },
    {
      name: 'video-poker',
      title: 'Video poker',
      icon: '/assets/images/v2/games/icons/video-poker.svg',
    },
    {
      name: 'hi-lo',
      title: 'Hi-lo',
      icon: '/assets/images/v2/games/icons/hi-lo.svg',
    },
    {
      name: 'casino-war',
      title: 'Casino war',
      icon: '/assets/images/v2/games/icons/casino-war.svg',
    },
    {
      name: 'under-the-aegis',
      title: 'Under the aegis',
      icon: '/assets/images/v2/games/icons/slots.svg',
    },
  ];
  chips: Array<Number> = [0.5, 1, 5, 10, 25, 100].reverse();
  chipsController: Array<Number> = [1, 5, 10, 25, 100];
  chipsControllerV3: Array<Number> = [1, 5, 10, 25, 100, 200];
  constructor(private http: Http, private auth: AuthenticationService) {}

  getLogs(type: string = 'all', rows: number = 10) {
    const options: RequestOptions = new RequestOptions();
    const params = new URLSearchParams();

    if (type) {
      params.set('type', type);
    }
    if (rows) {
      params.set('limit', rows.toString());
    }

    options.search = params;
    return this.http
      .get('/api/history/last-games', options)
      .toPromise()
      .then(data => {
        return data.json();
      });
  }

  getHistory(rows: number = 30, game: string = null, page: number = 0) {
    const options: RequestOptions = new RequestOptions();
    const params = new URLSearchParams();

    if (rows) {
      params.set('limit', rows.toString());
    }
    if (game) {
      params.set('game', game);
    }
    if (page) {
      params.set('page', page.toString());
    }

    options.search = params;
    options.headers = this._headers();
    return this.http
      .get('/api/history/my-games', options)
      .toPromise()
      .then(data => {
        return data.json();
      });
  }

  /**
   * @returns {Headers}
   * @private
   */
  private _headers(): Headers {
    const headers: Headers = new Headers();
    headers.append('Authorization', this.auth.credentials.accessToken);
    return headers;
  }

  getGameDetails(name: string): GameDetails {
    const data = this.gamesDetails.find(game => game.name === name);
    if (data) {
      return data;
    } else {
      return { name: 'all', title: 'All games', icon: null };
    }
  }

  getLeaderboard(
    rows: number = 10,
    currency: CurrencyType = CurrencyType.EDG,
    type: 'monthly' | 'weekly' | 'daily' = 'monthly'
  ) {
    const options: RequestOptions = new RequestOptions();
    const params = new URLSearchParams();

    if (rows) {
      params.set('limit', rows.toString());
    }

    params.set('type', type);
    params.set('currency', currency);

    options.search = params;
    return this.http.get('/api/history/leaderboard', options).pipe(map(response => response.json()));
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/core/games.service.ts